// extracted by mini-css-extract-plugin
export default {"suggestions":"rfwNofBnScFIe1hO8i1s","subtitle":"d8JiL96IrkQzo4vHvryw","tracks":"IyXm4UgcQAXwJEamjAk1"};